import CompLayout from "@/pcomponents/comp_stu/layout/layout";
import StuUseListArea from "@/pages/comp_stu/textbook/common/stu_use_list";

function StuUseListPage(){
  return (
    <CompLayout>
      <StuUseListArea></StuUseListArea>
    </CompLayout>
  );
}

export default StuUseListPage;